<template>
  <div id="showroom-homepage">
    <div class="main-content-wrapper">
      <div class="showroom-backgrounds-container">
        <transition name="fade">
          <div
            class="showroom-background fade-transition"
            :style="{ backgroundImage: `url(${backgroundImg})` }"
          ></div>
        </transition>
      </div>
      <div class="main-content container-fluid">
        <HomeSidebar />
      </div>
    </div>
  </div>
</template>

<script>
//import ProjectLoader from "@/components/Utils/ProjectLoader";
import HomeSidebar from "@/components/Projects/Showrooms/Homepage/HomeSidebar";

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "ShowroomHome",

  computed: {
    ...mapState(["loading"]),
    ...mapState("showroom", ["showroomPath"]),
    ...mapGetters("dealer", ["rhinoCode"]),
    ...mapGetters("project", ["projectColors"]),

    backgroundImg() {
      return require(`@/assets/images/${this.showroomPath}.png`);
    },

    color1() {
      return this.projectColors && this.projectColors[0].hex
        ? this.hexToRgba(this.projectColors[0].hex)
        : "rgba(255, 255, 255, 0.3)";
    },

    color2() {
      return this.projectColors && this.projectColors[1].hex
        ? this.hexToRgba(this.projectColors[1].hex)
        : "rgba(255, 255, 255, 0.3)";
    },

    color3() {
      return this.projectColors && this.projectColors[2].hex
        ? this.hexToRgba(this.projectColors[2].hex)
        : "rgba(255, 255, 255, 0.3)";
    },
  },

  methods: {
    ...mapActions("showroom", ["init"]),

    hexToRgba(hex) {
      // Remove the hash symbol (#) from the beginning of the hex code
      hex = hex.replace("#", "");

      // Convert the hex code to an RGB color code
      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);

      // Return the RGB color code as a string
      return `rgb(${r}, ${g}, ${b}, 0.3)`;
    },
  },

  components: {
    HomeSidebar,
    // ProjectLoader
  },

  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
#app {
  #showroom-homepage {
    max-height: 100vh;
    background-color: #fefefe;
    .fade-transition {
      transition: opacity 0.5s;
    }

    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }
    .showroom-backgrounds-container {
      position: absolute;
      display: flex;
      width: 100%;
      height: 100%;

      .showroom-background {
        flex: 1;
        background-position: center !important;
        background-size: cover !important;
        position: relative;
      }
    }

    .main-content-wrapper {
      display: flex;
      place-items: center;
      // height: 810px;
      //background-color: $fsgDark;

      .main-content {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        max-width: 1440px;
        min-height: 100vh;
        z-index: 2;

        ::v-deep .color-picker-multiple-container {
          overflow-y: scroll;
          max-height: 50vh;

          .color-picker-multiple-header {
            position: sticky;
            top: 0;
            z-index: 10;
          }
        }
      }
    }
  }
}
</style>
